export const SET_USER = "SET_USER";
export const CHANGE_THEME = "CHANGE_THEME";
export const CHANGE_CART = "CHANGE_CART";
export const CHANGE_SETTING = "CHANGE_SETTING";
